

import Vue from 'vue'
import App from './App'
import router from './router'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import axiosPlugin, { baseURL } from './server'
import BaiduMap from 'vue-baidu-map'
import '../static/css/reset.css'
import '../static/css/public.css'
import 'url-search-params-polyfill'





Vue.use(ToastPlugin, { position: 'middle' })
Vue.use(LoadingPlugin)
Vue.use(BaiduMap, {
ak: 'w27M9XJoHf4SSt9emhLkQDJlDXQ401YN'
})

Vue.config.productionTip = false

Vue.use(axiosPlugin)

Vue.prototype.baseURL = baseURL

Vue.filter('cutStr', function (str, num) {
if (str) {
let res = str.length > num ? str.slice(0, num) + '...' : str
return res
} else {
return ''
}
})

Vue.prototype.getUrlPramas = function (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
var r = window.location.search.substr(1).match(reg)
if (r != null) {
return unescape(r[2])
} else {
return null
}
}

Vue.prototype.setCookie = function (cName, value, expire) {
var date = new Date()
date.setHours(date.getHours() + 24 * expire) 
document.cookie = cName + '=' + escape(value) + '; expires=' + date.toGMTString()
}

Vue.prototype.getCookie = function (cName) {
if (cName === '') {
return ''
} else if (document.cookie.length > 0) {
var cStart = document.cookie.indexOf(cName + '=')
if (cStart !== -1) {
cStart = cStart + cName.length + 1
var cEnd = document.cookie.indexOf(';', cStart)
if (cEnd === -1) cEnd = document.cookie.length
return decodeURI(document.cookie.substring(cStart, cEnd))
}
}
return ''
}

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js